// extracted by mini-css-extract-plugin
export var panel = "styles-module--panel--d2860";